import { VideoIcon, SliderIcon, PageIcon, ImageIcon, ComponentIcon, TextIcon, SpeakerIcon, AccordionIcon, LinkIcon, EmbedIcon } from '@ui/kit';
import { BlockTypes } from '../../../../models/block.js';
import { BlockElementTypes } from '../../../../models/reference-block.js';
import { iconCls } from './block-icon.style.js';
import { jsx } from 'react/jsx-runtime';

function BlockIcon(props) {
  let icon;
  switch (props.block.type) {
    case BlockTypes.EMBED:
      icon = /*#__PURE__*/jsx(EmbedIcon, {});
      break;
    case BlockTypes.LINK:
      icon = /*#__PURE__*/jsx(LinkIcon, {});
      break;
    case BlockTypes.RICHTEXT:
      icon = /*#__PURE__*/jsx(TextIcon, {});
      break;
    case BlockTypes.YOUTUBE:
      icon = /*#__PURE__*/jsx(VideoIcon, {});
      break;
    case BlockTypes.REFERENCE:
      {
        switch (props.block.element.type) {
          case BlockElementTypes.ACCORDION:
            icon = /*#__PURE__*/jsx(AccordionIcon, {});
            break;
          case BlockElementTypes.AUDIO:
            icon = /*#__PURE__*/jsx(SpeakerIcon, {});
            break;
          case BlockElementTypes.COMPLEXT_CONTENT:
          case BlockElementTypes.RICHTEXT:
            icon = /*#__PURE__*/jsx(TextIcon, {});
            break;
          case BlockElementTypes.IBOOK:
          case BlockElementTypes.IFRAME:
            icon = /*#__PURE__*/jsx(ComponentIcon, {});
            break;
          case BlockElementTypes.IMAGE:
            icon = /*#__PURE__*/jsx(ImageIcon, {});
            break;
          case BlockElementTypes.PAGE:
            icon = /*#__PURE__*/jsx(PageIcon, {});
            break;
          case BlockElementTypes.SLIDER:
            icon = /*#__PURE__*/jsx(SliderIcon, {});
            break;
          case BlockElementTypes.VIDEO:
            icon = /*#__PURE__*/jsx(VideoIcon, {});
        }
      }
      break;
  }
  return /*#__PURE__*/jsx("span", {
    className: iconCls,
    children: icon
  });
}

export { BlockIcon };
//# sourceMappingURL=block-icon.js.map
